export const DEPOT_HOST = process.env.NEXT_PUBLIC_DEPOT_HOST;
export const CRM_HOST = process.env.NEXT_PUBLIC_CRM_HOST;
